import React, { useState, useEffect } from 'react';

const FN_URL = 'https://btdlohjmjogzkefjmvpn.supabase.co/functions/v1/avaliacao-cliente';
const C = { purple:'#691FB1', purpleLight:'#EDE7F6', border:'#E4DEFA', text:'#1A1A2E', textLight:'#8888AA', white:'#fff', green:'#27AE60', bg:'#F7F5FC' };

async function chamar(body) {
  const res = await fetch(FN_URL, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify(body) });
  return res.json();
}

const PERGUNTAS_15 = [
  { key:'p1', titulo:'Qualidade dos serviços prestados neste semestre', sub:'Considere a qualidade técnica e a postura dos profissionais que estiveram na vossa empresa.' },
  { key:'p2', titulo:'Equipa que acompanha a vossa empresa', sub:'Rapidez de resposta, capacidade de resolver imprevistos e proatividade.' },
  { key:'p3', titulo:'Resposta comercial', sub:'Rapidez, clareza e adequação das propostas às vossas necessidades.' },
  { key:'p4', titulo:'Informação e reporting', sub:'Clareza e utilidade dos relatórios e dos dados que recebem.' },
  { key:'p5', titulo:'Impacto e valor', sub:'Impacto percebido no bem-estar dos colaboradores face ao investimento feito.' },
];

function labelSemestre(s) {
  if (!s) return '';
  const [ano, sem] = s.split('-');
  return sem === 'S1' ? `1.º semestre de ${ano}` : `2.º semestre de ${ano}`;
}

export default function AvaliacaoCliente() {
  const [codigo, setCodigo] = useState('');
  const [estado, setEstado] = useState('a-abrir'); // a-abrir | pronto | ja-respondeu | invalido | submetido
  const [clienteNome, setClienteNome] = useState('');
  const [semestre, setSemestre] = useState('');
  const [erro, setErro] = useState('');
  const [resp, setResp] = useState({ p1:null,p2:null,p3:null,p4:null,p5:null,p6:null,p7:'' });
  const [aGravar, setAGravar] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const c = params.get('c') || params.get('codigo') || '';
    if (!c) { setEstado('invalido'); setErro('Ligação sem código de acesso.'); return; }
    setCodigo(c);
    (async () => {
      const r = await chamar({ acao:'abrir', codigo: c });
      if (!r.ok) { setEstado('invalido'); setErro(r.error || 'Ligação inválida.'); return; }
      setClienteNome(r.cliente_nome || '');
      setSemestre(r.semestre || '');
      if (r.jaRespondeu) { setEstado('ja-respondeu'); return; }
      setEstado('pronto');
    })();
  }, []);

  const submeter = async () => {
    if (resp.p6 == null) { setErro('Por favor responda à pergunta de recomendação (0 a 10).'); return; }
    setAGravar(true); setErro('');
    const r = await chamar({ acao:'submeter', codigo, ...resp });
    setAGravar(false);
    if (!r.ok) {
      if (r.error && r.error.includes('semestre')) { setEstado('ja-respondeu'); return; }
      setErro(r.error || 'Erro ao submeter.'); return;
    }
    setEstado('submetido');
  };

  const wrap = { minHeight:'100vh', background:C.bg, fontFamily:"'DM Sans',sans-serif", padding:'24px 16px' };
  const card = { background:C.white, borderRadius:16, padding:32, maxWidth:620, margin:'0 auto', boxShadow:'0 8px 40px rgba(105,31,177,0.10)' };
  const fonts = <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>;

  // Escala 1-5
  const Escala15 = ({ value, onChange }) => (
    <div style={{ display:'flex', gap:8, marginTop:10 }}>
      {[1,2,3,4,5].map(n => (
        <button key={n} onClick={()=>onChange(n)}
          style={{ flex:1, padding:'12px 0', borderRadius:9, border:`1.5px solid ${value===n?C.purple:C.border}`,
            background: value===n?C.purple:C.white, color: value===n?'#fff':C.text, fontSize:16, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
          {n}
        </button>
      ))}
    </div>
  );

  // NPS 0-10
  const EscalaNPS = ({ value, onChange }) => (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(11, 1fr)', gap:5, marginTop:10 }}>
      {[0,1,2,3,4,5,6,7,8,9,10].map(n => (
        <button key={n} onClick={()=>onChange(n)}
          style={{ padding:'10px 0', borderRadius:8, border:`1.5px solid ${value===n?C.purple:C.border}`,
            background: value===n?C.purple:C.white, color: value===n?'#fff':C.text, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
          {n}
        </button>
      ))}
    </div>
  );

  if (estado === 'a-abrir') {
    return <div style={wrap}>{fonts}<div style={card}><p style={{ color:C.textLight, textAlign:'center' }}>A carregar…</p></div></div>;
  }

  if (estado === 'invalido') {
    return <div style={wrap}>{fonts}<div style={card}>
      <div style={{ textAlign:'center', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:26, fontWeight:700, marginBottom:12 }}>Workwell</div>
      <p style={{ color:'#C0392B', textAlign:'center', fontSize:14 }}>{erro}</p>
      <p style={{ color:C.textLight, textAlign:'center', fontSize:13 }}>Contacte a Workwell se acha que se trata de um erro.</p>
    </div></div>;
  }

  if (estado === 'ja-respondeu') {
    return <div style={wrap}>{fonts}<div style={card}>
      <div style={{ textAlign:'center', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:26, fontWeight:700, marginBottom:12 }}>Workwell</div>
      <div style={{ textAlign:'center', fontSize:40, marginBottom:8 }}>✓</div>
      <h1 style={{ fontFamily:"'Fraunces',serif", color:C.text, fontSize:20, textAlign:'center', margin:'0 0 8px' }}>Avaliação já submetida</h1>
      <p style={{ color:C.textLight, textAlign:'center', fontSize:14, lineHeight:1.5 }}>Já recebemos a vossa avaliação do {labelSemestre(semestre)}. Muito obrigada pelo vosso tempo!</p>
    </div></div>;
  }

  if (estado === 'submetido') {
    return <div style={wrap}>{fonts}<div style={card}>
      <div style={{ textAlign:'center', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:26, fontWeight:700, marginBottom:12 }}>Workwell</div>
      <div style={{ textAlign:'center', fontSize:40, marginBottom:8 }}>🎉</div>
      <h1 style={{ fontFamily:"'Fraunces',serif", color:C.text, fontSize:20, textAlign:'center', margin:'0 0 8px' }}>Obrigada pela vossa avaliação!</h1>
      <p style={{ color:C.textLight, textAlign:'center', fontSize:14, lineHeight:1.5 }}>O vosso feedback ajuda-nos a melhorar continuamente o serviço. Até ao próximo semestre!</p>
    </div></div>;
  }

  // estado === 'pronto' -> formulário
  return (
    <div style={wrap}>
      {fonts}
      <div style={card}>
        <div style={{ textAlign:'center', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:24, fontWeight:700, marginBottom:6 }}>Workwell</div>
        <h1 style={{ fontFamily:"'Fraunces',serif", color:C.text, fontSize:21, textAlign:'center', margin:'0 0 6px' }}>Avaliação de satisfação</h1>
        <p style={{ color:C.textLight, textAlign:'center', fontSize:13, margin:'0 0 4px' }}>{clienteNome}{clienteNome?' · ':''}{labelSemestre(semestre)}</p>
        <p style={{ color:C.textLight, textAlign:'center', fontSize:13, lineHeight:1.5, margin:'0 0 24px' }}>A vossa opinião é muito importante. Demora menos de 2 minutos.</p>

        {PERGUNTAS_15.map((p, i) => (
          <div key={p.key} style={{ marginBottom:22, paddingBottom:22, borderBottom:`1px solid ${C.border}` }}>
            <div style={{ fontSize:15, fontWeight:700, color:C.text }}>{i+1}. {p.titulo}</div>
            <div style={{ fontSize:13, color:C.textLight, marginTop:3 }}>{p.sub}</div>
            <Escala15 value={resp[p.key]} onChange={v=>setResp(r=>({...r,[p.key]:v}))} />
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:C.textLight, marginTop:5 }}>
              <span>Muito insatisfeito</span><span>Muito satisfeito</span>
            </div>
          </div>
        ))}

        <div style={{ marginBottom:22, paddingBottom:22, borderBottom:`1px solid ${C.border}` }}>
          <div style={{ fontSize:15, fontWeight:700, color:C.text }}>6. Qual a probabilidade de recomendar a Workwell a outro colega de RH?</div>
          <EscalaNPS value={resp.p6} onChange={v=>setResp(r=>({...r,p6:v}))} />
          <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:C.textLight, marginTop:5 }}>
            <span>Nada provável</span><span>Muito provável</span>
          </div>
        </div>

        <div style={{ marginBottom:22 }}>
          <div style={{ fontSize:15, fontWeight:700, color:C.text }}>7. O que devemos melhorar no próximo semestre?</div>
          <textarea value={resp.p7} onChange={e=>setResp(r=>({...r,p7:e.target.value}))} rows={4}
            placeholder="A vossa resposta (opcional)…"
            style={{ width:'100%', marginTop:10, padding:'11px 13px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', resize:'vertical' }} />
        </div>

        {erro && <div style={{ background:'#FDEDEC', borderRadius:8, padding:'10px 12px', fontSize:13, color:'#C0392B', marginBottom:14 }}>{erro}</div>}

        <button onClick={submeter} disabled={aGravar}
          style={{ width:'100%', padding:'14px', background:C.purple, border:'none', borderRadius:10, color:'white', fontSize:15, fontWeight:700, cursor:aGravar?'default':'pointer', opacity:aGravar?0.6:1, fontFamily:"'DM Sans',sans-serif" }}>
          {aGravar ? 'A submeter…' : 'Submeter avaliação'}
        </button>
      </div>
    </div>
  );
}
